import React, { useEffect, useState } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Button,
  Divider,
  TextField,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import OrdinanceDialog from "./OrdinanceDialog";
import axios from "axios";
import { BACKEND_BASE_URL } from "../../config";
import { ExpandMore } from "@material-ui/icons";
import TranscriptDialog from "./TranscriptDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import he from 'he';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" {...props} ref={ref} />;
});

const VedioDialog = ({ open, onClose, state, county, municipalityName, channelName, videos, channel_url, associated_towns, onRefreshVideos }) => {


  const [expandedSummaries, setExpandedSummaries] = useState({}); // Track expanded summaries per video
  const [selectedOrdinance, setSelectedOrdinance] = useState(null);
  const [updatedVideos, setUpdatedVideos] = useState(videos); // Local state to update videos dynamically
  const [expandedPlaylists, setExpandedPlaylists] = useState(new Set()); // Track expanded playlists as a Set
  const [transcript, setTranscript] = useState(null); // To store transcript
  const [loadingTranscript, setLoadingTranscript] = useState(false); // Loading state for transcript
  const [transcriptVideoId, setTranscriptVideoId] = useState(null);
  const [editedTranscriptByVideoId, setEditedTranscriptByVideoId] = useState({});
  const [pendingTranscriptRefreshByVideoId, setPendingTranscriptRefreshByVideoId] = useState({});
  const [searchQueries, setSearchQueries] = useState({}); // Search queries for each playlist
  const [loadingRegVideo, setLoadingRegVideo] = useState({}); // Specifically for Brown button
  const [loadingRegTranscript, setLoadingRegTranscript] = useState({}); // Specifically for Green button
  const [globalLoading, setGlobalLoading] = useState(false)

  const maxItems = 5;

  // Keep local dialog state in sync when parent refreshes playlist videos.
  useEffect(() => {
    setUpdatedVideos(videos || {});
  }, [videos]);

  const getCSRFToken = () => {
    const csrfCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('csrftoken='));
    return csrfCookie ? csrfCookie.split('=')[1] : null;
  };

  const handleSearchChange = (playlistName, query) => {
    setSearchQueries((prev) => ({
      ...prev,
      [playlistName]: query,
    }));
  };

  // const reGenerateSummary = async (videoId, state, county, municipalityName, channel_url) => {
  //   const csrfToken = getCSRFToken();
  //   const data = [
  //     {
  //       video_id: videoId,
  //       state: state,
  //       county: county,
  //       municipality: municipalityName,
  //       channel_url: channel_url
  //     }
  //   ]
  //   // setGlobalLoading(true)

  //   setLoadingRegeneration((prev) => ({ ...prev, [videoId]: true })); // Start loading
  //   try {
  //     const response = await axios.post(`${BACKEND_BASE_URL}/api/regenerate-summary/`, { data: data }, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-CSRFToken": csrfToken, // Include the CSRF token
  //       },
  //       withCredentials: true, // Ensure cookies are sent with the request
  //     })


  //     setLoadingRegeneration((prev) => ({ ...prev, [videoId]: false })); // Stop loading
  //     // setGlobalLoading(false)
  //     toast.success("Regenrated summary succesfully!")
  //     onClose()
  //     return response.data
  //   }
  //   catch (error) {
  //     console.error('Error calling API:', error);
  //     setLoadingRegeneration((prev) => ({ ...prev, [videoId]: false })); // Stop loading
  //     // setGlobalLoading(false)
  //     toast.error("Error regenerating summary! Please try again later."); // Show error message
  //     throw error; // Handle error appropriately
  //   }

  // }
  /** Backend requires keys to be present; JSON.stringify drops undefined, causing 400. */
  const str = (v) => (v == null ? "" : String(v));

  const reGenerateSummary = async (videoId, state, county, municipalityName, channel_url) => {
    const csrfToken = getCSRFToken();
    const editedTranscript = editedTranscriptByVideoId[videoId];
    const hasEditedTranscript = !!(editedTranscript && String(editedTranscript).trim());

    if (!hasEditedTranscript && !window.confirm("No edited transcript found. This will regenerate using the current saved transcript. Continue?")) {
      return;
    }

    const data = [
      {
        video_id: str(videoId),
        state: str(state),
        county: str(county),
        municipality: str(municipalityName),
        channel_url: str(channel_url),
        ...(hasEditedTranscript ? { transcript_text: editedTranscript } : {}),
      }
    ];

    setLoadingRegTranscript((prev) => ({ ...prev, [videoId]: true })); // Only Green button
    try {
      const response = await axios.post(`${BACKEND_BASE_URL}/api/regenerate-summary/`, JSON.stringify({ data }), {
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        withCredentials: true,
      });

      if (response.status === 200 && response.data?.summaries) {
        setUpdatedVideos((prev) =>
          Object.fromEntries(
            Object.entries(prev).map(([playlistName, videoList]) => [
              playlistName,
              videoList.map((v) =>
                v.video_id === videoId ? { ...v, summaries: response.data.summaries } : v
              ),
            ])
          )
        );

        setLoadingRegTranscript((prev) => ({ ...prev, [videoId]: false }));
        toast.success("Re-generated summary successfully!");
        if (typeof onRefreshVideos === "function") await onRefreshVideos();
        return response.data;
      }

      if (response.status === 202 || !response.data?.summaries) {
        setLoadingRegTranscript((prev) => ({ ...prev, [videoId]: false }));
        toast.info("Summary generating in backend.");
        if (typeof onRefreshVideos === "function") {
          setTimeout(() => {
            onRefreshVideos();
          }, 5000);
        }
        return response.data;
      }

      setLoadingRegTranscript((prev) => ({ ...prev, [videoId]: false }));
      toast.success("Re-generated summary successfully!");
      if (typeof onRefreshVideos === "function") await onRefreshVideos();
      return response.data;
    } catch (error) {
      console.error("Error calling API:", error);
      setLoadingRegTranscript((prev) => ({ ...prev, [videoId]: false }));

      if (
        error.response?.status === 504 ||
        error.code === "ECONNABORTED" ||
        error.code === "ERR_NETWORK" ||
        String(error.message).toLowerCase().includes("timeout")
      ) {
        toast.info("Summary generating in backend.");
        return;
      }

      const status = error.response?.status;
      const errData = error.response?.data;
      const errMsg =
        (typeof errData === "object" && errData && (errData.message || errData.error)) ||
        (typeof errData === "string" ? errData : null);
      if (status === 400) toast.error(errMsg || "Bad request while regenerating");
      else if (status === 401 || status === 403) toast.error(error.response?.data?.message || "Unauthorized");
      else if (status === 429) toast.error(error.response?.data?.message || "Too many requests");
      else if (status >= 500) toast.error("Server error while regenerating summary");
      else toast.error("Error regenerating summary! Please try again later.");

      // Do not rethrow — avoids "Uncaught (in promise)" after toast; error already logged above.
      return null;
    }
  };

  const pollTranscriptTaskStatus = async (videoId, taskId) => {
    const maxAttempts = 20;
    const intervalMs = 3000;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      try {
        const statusResponse = await axios.get(`${BACKEND_BASE_URL}/api/transcript-tasks/${taskId}/`);
        const taskStatus = statusResponse?.data?.status;

        if (taskStatus === "SUCCESS") {
          const refreshedResponse = await axios.get(`${BACKEND_BASE_URL}/api/transcripts/${videoId}/`);
          const refreshedTranscript = refreshedResponse?.data?.transcript_text || "";

          setEditedTranscriptByVideoId((prev) => ({
            ...prev,
            [videoId]: refreshedTranscript,
          }));
          setTranscript((prev) => (
            prev && prev.video_id === videoId ? refreshedResponse.data : prev
          ));
          toast.success("Transcript refreshed from Webshare-YT.");
          return;
        }

        if (taskStatus === "FAILURE") {
          const errorMessage = statusResponse?.data?.result?.error || "Transcript regeneration failed from Webshare-YT.";
          toast.error(errorMessage);
          return;
        }
      } catch (pollError) {
        console.error("Error polling transcript task status:", pollError);
      }

      await new Promise((resolve) => window.setTimeout(resolve, intervalMs));
    }

    toast.info("Transcript is still generating in the background. Please click View Transcript again in a few moments.");
  };

  const reGenerateFromVideo = async (videoId, source = "video") => {
    const loadingKey = source === "webshare" ? `${videoId}_webshare` : videoId;
    setLoadingRegVideo((prev) => ({ ...prev, [loadingKey]: true })); // Trigger specified loader
    try {
      const response = await axios.post(`${BACKEND_BASE_URL}/api/transcripts/${videoId}/`, {
        source: source,
      });

      if (response.status === 202) {
        setPendingTranscriptRefreshByVideoId((prev) => ({
          ...prev,
          [videoId]: true,
        }));
        toast.info("Transcript is generating in the background. Please wait 15 seconds before clicking View Transcript.");
        const taskId = response?.data?.task_id;
        if (taskId) {
          await pollTranscriptTaskStatus(videoId, taskId);
        }
        setLoadingRegVideo((prev) => ({ ...prev, [loadingKey]: false }));
        setPendingTranscriptRefreshByVideoId((prev) => {
          const next = { ...prev };
          delete next[videoId];
          return next;
        });
        return;
      }

      const refreshedTranscript = response?.data?.transcript_text || "";
      if (!refreshedTranscript.trim()) {
        toast.error("No transcript returned from video.");
        return;
      }

      setEditedTranscriptByVideoId((prev) => ({
        ...prev,
        [videoId]: refreshedTranscript,
      }));

      // Directly update the transcript dialog if it's open for this video
      if (transcriptVideoId === videoId) {
        setTranscript((prev) => ({
          ...(prev || {}),
          transcript_text: refreshedTranscript,
        }));
      }

      toast.success("Transcript refreshed from video. You can now view it and edit, or click Regen/Transcript.");
    } catch (error) {
      console.error("Error refreshing transcript from video:", error);
      const message = error?.response?.data?.message || "Failed to refresh transcript from video.";
      toast.error(message);
    } finally {
      setLoadingRegVideo((prev) => ({ ...prev, [loadingKey]: false }));
    }
  };


  const handleOrdinanceClick = (ordinance) => {
    setSelectedOrdinance(ordinance);
  };

  const handleOrdinanceClose = () => {
    setSelectedOrdinance(null);
  };

  const handleOrdinanceSave = async (updatedOrdinance) => {
    try {
      const response = await axios.put(
        `${BACKEND_BASE_URL}/api/ordinances/${updatedOrdinance.uuid}/`,
        {
          name: updatedOrdinance.name,
          short_summary: updatedOrdinance.short_summary,
          long_summary: updatedOrdinance.long_summary,
          categories: updatedOrdinance.categories,
        }
      );


      setUpdatedVideos((prevVideos) =>
        Object.fromEntries(
          Object.entries(prevVideos).map(([playlistName, videoList]) => [
            playlistName,
            videoList.map((video) => ({
              ...video,
              summaries: video.summaries.map((ordinance) =>
                ordinance.uuid === updatedOrdinance.uuid
                  ? { ...ordinance, ...updatedOrdinance }
                  : ordinance
              ),
            })),
          ])
        )
      );

      setSelectedOrdinance(null);
    } catch (error) {
      console.error("Error updating ordinance:", error);
    }
  };

  const handlePlaylistToggle = (playlistName) => {
    setExpandedPlaylists((prev) => {
      const newExpandedPlaylists = new Set(prev);
      if (newExpandedPlaylists.has(playlistName)) {
        newExpandedPlaylists.delete(playlistName);
      } else {
        newExpandedPlaylists.add(playlistName);
      }
      return newExpandedPlaylists;
    });
  };

  const toggleSummary = (videoId) => {
    setExpandedSummaries((prev) => ({
      ...prev,
      [videoId]: !prev[videoId],
    }));
  };

  const getFilteredVideos = (videoList, query) => {

    return videoList
      .filter((video) =>
        video.title.toLowerCase().includes(query?.toLowerCase() || "")
      )
      .sort((a, b) => new Date(b.published_at) - new Date(a.published_at));
  };

  const fetchTranscript = async (videoId) => {
    if (pendingTranscriptRefreshByVideoId[videoId]) {
      toast.info("Transcript is generating in the background. Please wait 15 seconds before clicking View Transcript.");
      return;
    }

    setTranscriptVideoId(videoId);
    setLoadingTranscript(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/transcripts/${videoId}/`);
      setTranscript(response.data);
    } catch (error) {
      console.error("Error fetching transcript:", error);
      setTranscript(null);
    } finally {
      setLoadingTranscript(false);
    }
  };

  const handleSaveTranscript = async (videoId, transcriptText) => {
    if (!videoId) return;
    if (!String(transcriptText || "").trim()) {
      toast.error("Transcript cannot be empty.");
      return;
    }

    try {
      await axios.put(`${BACKEND_BASE_URL}/api/transcripts/${videoId}/`, {
        transcript_text: transcriptText,
      });

      setEditedTranscriptByVideoId((prev) => ({
        ...prev,
        [videoId]: transcriptText,
      }));

      setTranscript((prev) =>
        prev ? { ...prev, transcript_text: transcriptText } : prev
      );

      toast.success("Transcript saved. Re-Generate will use this edited text.");
    } catch (error) {
      console.error("Error saving transcript:", error);
      const message = error?.response?.data?.message || "Failed to save transcript.";
      toast.error(message);
      throw error;
    }
  };


  return (
    <>
      <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition} unmountOnExit={false}>
        <AppBar position="static" style={{ backgroundColor: "#0B194A", color: "white" }}>
          <Toolbar>
            <Typography variant="h6" style={{ flex: 1 }}>
              Selected Videos
            </Typography>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ToastContainer />
        <Box
          style={{
            margin: "20px",
            marginTop: "90px",
            padding: "20px",
            minHeight: "100%",
            backgroundColor: "white",
          }}
        >
          <div style={{ marginBottom: "20px" }}>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              Municipality Name: {municipalityName}
              {associated_towns.length > 0 && (
                <span style={{ fontWeight: "normal", color: "#555", marginLeft: "8px" }}>
                  (Associated Towns: {associated_towns
                    .map(town => town.municipality_name.replace(/\b\w/g, char => char.toUpperCase()))
                    .join(", ")})
                </span>
              )}
            </Typography>


            <Typography variant="h6" style={{ color: "#555" }}>
              Channel Name: {channelName}
            </Typography>
          </div>
          {Object.keys(updatedVideos).length === 0 ? (
            <Typography variant="h6" style={{ color: "#777" }}>
              No playlists selected.
            </Typography>
          ) : (
            Object.entries(updatedVideos).map(([playlistName, videoList]) => {
              const searchQuery = searchQueries[playlistName] || "";
              const filteredVideos = getFilteredVideos(videoList, searchQuery);
              return (
                <div key={playlistName} style={{ marginBottom: "20px" }}>
                  <Button
                    onClick={() => handlePlaylistToggle(playlistName)}
                    style={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                      width: "100%",
                      borderRadius: "5px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: "black",
                    }}
                  >
                    <Typography variant="h5">{playlistName === "Whole Channel" ? "MAIN CHANNEL" : playlistName}</Typography>
                    <ExpandMore
                      style={{
                        transform: expandedPlaylists.has(playlistName)
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.3s",
                      }}
                    />
                  </Button>
                  <Divider style={{ marginTop: "10px", height: "4px", backgroundColor: "#0B194A" }} />
                  <Collapse in={expandedPlaylists.has(playlistName)} timeout="auto" unmountOnExit>
                    {videoList.length === 0 ? (
                      <Typography variant="h6" style={{ margin: "20px 0", color: "#777" }}>
                        No videos to show.
                      </Typography>
                    ) : (
                      <Table
                        style={{
                          marginTop: "20px",
                          border: "1px solid #ddd",
                          width: "100%",
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{
                                backgroundColor: "#152F8F",
                                color: "#fff",
                                fontWeight: "bold",
                              }}
                            >
                              Video Title
                            </TableCell>
                            <TableCell
                              style={{
                                backgroundColor: "#152F8F",
                                color: "#fff",
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span> Summaries</span>
                              {/* Search Input in Summaries Header */}
                              <TextField
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <FontAwesomeIcon
                                      icon={faMagnifyingGlass}
                                      style={{ marginRight: "8px", color: "#555" }}
                                    />
                                  ),
                                }}
                                placeholder="Search Videos"
                                value={searchQuery}
                                onChange={(e) => handleSearchChange(playlistName, e.target.value)}
                                style={{ backgroundColor: "white", borderRadius: "5px", }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredVideos.map((video, index) => (
                            <TableRow key={index}>
                              <TableCell style={{ border: "1px solid #ddd" }}>
                                <Box style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                  <a
                                    href={video.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none", color: "#152F8F" }}
                                  >
                                    {he.decode(video.title)}
                                  </a>
                                  <Button
                                    onClick={() => fetchTranscript(video.video_id)}
                                    style={{
                                      width: "50%",
                                      backgroundColor: "#0B194A",
                                      color: "white",
                                      marginTop: "10px",
                                    }}
                                  >
                                    View Transcript
                                  </Button>
                                  <Button
                                    onClick={() => reGenerateFromVideo(video.video_id)}
                                    disabled={loadingRegVideo[video.video_id] || loadingRegTranscript[video.video_id] || globalLoading}
                                    style={{
                                      width: "100%",
                                      backgroundColor: "#8A5A00",
                                      color: "white",
                                      marginTop: "10px",
                                      fontSize: "12px"
                                    }}
                                  >
                                    {loadingRegVideo[video.video_id] ? (
                                      <CircularProgress size={20} style={{ color: "white" }} />
                                    ) : (
                                      "REGEN/VIDEO (APIFY)"
                                    )}
                                  </Button>
                                  <Button
                                    onClick={() => reGenerateFromVideo(video.video_id, "webshare")}
                                    disabled={loadingRegVideo[video.video_id] || loadingRegTranscript[video.video_id] || globalLoading}
                                    style={{
                                      width: "100%",
                                      backgroundColor: "#1976d2",
                                      color: "white",
                                      marginTop: "10px",
                                      fontSize: "12px"
                                    }}
                                  >
                                    {loadingRegVideo[`${video.video_id}_webshare`] ? (
                                      <CircularProgress size={20} style={{ color: "white" }} />
                                    ) : (
                                      "REGEN USING WEBSHARE-YT"
                                    )}
                                  </Button>
                                  <Button
                                    onClick={() => reGenerateSummary(video.video_id, state, county, municipalityName, channel_url)}
                                    disabled={loadingRegVideo[video.video_id] || loadingRegTranscript[video.video_id] || globalLoading}
                                    style={{
                                      width: "100%",
                                      backgroundColor: "green",
                                      color: "white",
                                      marginTop: "10px",
                                      fontSize: "12px"
                                    }}
                                  >
                                    {loadingRegTranscript[video.video_id] ? (
                                      <CircularProgress size={20} style={{ color: "white" }} />
                                    ) : (
                                      "Regen Summary"
                                    )}
                                  </Button>
                                </Box>
                              </TableCell>
                              <TableCell style={{ border: "1px solid #ddd" }}>
                                <ul style={{ margin: 0, padding: 0 }}>

                                  {(loadingRegVideo[video.video_id] || loadingRegTranscript[video.video_id]) ? (
                                    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}><CircularProgress size={24} style={{ color: "black", margin: 'auto', alignItems: 'center' }} /></Box>

                                  ) : (
                                    <>
                                      {(video.summaries || []).length === 0 ? (
                                        <Typography
                                          variant="body2"
                                          style={{ color: "#666", fontStyle: "italic", padding: "4px 0" }}
                                        >
                                          No summaries yet. Use <strong>Regen/Transcript</strong> to generate a new summary.
                                        </Typography>
                                      ) : (
                                        <>
                                          {(video.summaries || [])
                                            .slice(0, expandedSummaries[video.video_id] ? (video.summaries || []).length : maxItems)
                                            .map((ordinance, idx) => (
                                              <li key={idx}>
                                                <button
                                                  onClick={() => handleOrdinanceClick(ordinance)}
                                                  style={{
                                                    background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  {ordinance.num === "N/A" ? (
                                                    <>
                                                      {ordinance.name} (
                                                      {ordinance.categories.map((category) => category.name).join(", ")}
                                                      )
                                                    </>
                                                  ) : (
                                                    <>
                                                      <strong>{ordinance.num}</strong>: {ordinance.name} (
                                                      {ordinance.categories.map((category) => category.name).join(", ")}
                                                      )
                                                    </>
                                                  )}
                                                </button>
                                              </li>
                                            ))}
                                          {(video.summaries || []).length > maxItems && (
                                            <li style={{ listStyle: "none" }}>
                                              <button
                                                onClick={() => toggleSummary(video.video_id)}
                                                style={{
                                                  background: "none",
                                                  border: "none",
                                                  color: "blue",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {expandedSummaries[video.video_id] ? "View Less" : "View More"}
                                              </button>
                                            </li>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}

                                </ul>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    )}
                  </Collapse>
                </div>
              )
            })
          )}

        </Box>

      </Dialog>

      {/* <Backdrop open={globalLoading} style={{
        zIndex: 2000, // Ensure the backdrop is above other elements
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}>
        <CircularProgress style={{ color: "white" }} />
      </Backdrop> */}

      <TranscriptDialog
        open={Boolean(transcript) || loadingTranscript}
        transcript={transcript}
        loading={loadingTranscript}
        videoId={transcriptVideoId}
        onSaveTranscript={handleSaveTranscript}
        onClose={() => {
          setTranscript(null);
          setTranscriptVideoId(null);
        }}
      />

      {/* Ordinance Dialog */}
      {selectedOrdinance && (
        <OrdinanceDialog
          open={Boolean(selectedOrdinance)}
          onClose={handleOrdinanceClose}
          ordinance={selectedOrdinance}
          onSave={handleOrdinanceSave}
        />
      )}
    </>
  );
};

export default VedioDialog;
